import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translations
import enCommon from "../locales/en/common.json";
import enAuth from "../locales/en/auth.json";
import enDashboard from "../locales/en/dashboard.json";
import enScans from "../locales/en/scans.json";
import enDomains from "../locales/en/domains.json";
import enSettings from "../locales/en/settings.json";
import enComparisons from "../locales/en/comparisons.json";
import enSchedules from "../locales/en/schedules.json";

import esCommon from "../locales/es/common.json";
import esAuth from "../locales/es/auth.json";
import esDashboard from "../locales/es/dashboard.json";
import esScans from "../locales/es/scans.json";
import esDomains from "../locales/es/domains.json";
import esSettings from "../locales/es/settings.json";
import esComparisons from "../locales/es/comparisons.json";
import esSchedules from "../locales/es/schedules.json";

export const supportedLanguages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "es", name: "Español", flag: "🇪🇸" },
] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number]["code"];

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    scans: enScans,
    domains: enDomains,
    settings: enSettings,
    comparisons: enComparisons,
    schedules: enSchedules,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    dashboard: esDashboard,
    scans: esScans,
    domains: esDomains,
    settings: esSettings,
    comparisons: esComparisons,
    schedules: esSchedules,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "common",
    ns: ["common", "auth", "dashboard", "scans", "domains", "settings", "comparisons", "schedules"],

    detection: {
      // Order of language detection - localStorage first (user preference), then browser
      order: ["localStorage", "navigator", "htmlTag"],
      // Cache user's language choice in localStorage
      caches: ["localStorage"],
      // Key used in localStorage
      lookupLocalStorage: "i18nextLng",
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
